import { render, staticRenderFns } from "./TextInputs.vue?vue&type=template&id=5c27887c"
import script from "./TextInputs.vue?vue&type=script&lang=js"
export * from "./TextInputs.vue?vue&type=script&lang=js"
import style0 from "./TextInputs.vue?vue&type=style&index=0&id=5c27887c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports